import { Component, Inject, LOCALE_ID, OnInit } from '@angular/core';
import { Store } from '@ngrx/store';
import { ApiService, CoreUiPartialState, getOrderTypes } from '@pos-app/core-ui';
import { CustomerDetails, ListTasksNotes, OrderType } from '@pos-app/data';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { CustomersPartialState } from '../../+state/customers.reducer';
import { customersQuery } from '../../+state/customers.selectors';
import { GetAlertMessageAction, ListTasksNotesAction, UpdateAlertMessageAction } from '../../+state/customers.actions';
import { ActivatedRoute, RouterLink } from '@angular/router';
import { UntypedFormBuilder, UntypedFormGroup, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { getLocalLocaleDate } from '@pos-app/core-ui/lib/utils/utils-date';
import { Location, NgIf, AsyncPipe } from '@angular/common';
import { CoreUiModule } from '../../../../../../../../libs/core-ui/src/lib/core-ui.module';

@Component({
    selector: 'app-customers-notes',
    templateUrl: './customers-notes.component.html',
    styleUrls: ['./customers-notes.component.scss'],
    imports: [NgIf, CoreUiModule, RouterLink, FormsModule, ReactiveFormsModule, AsyncPipe]
})
export class CustomersNotesComponent implements OnInit {
  public loadingTasksNotesList$ = this.store.select(customersQuery.getLoadingTasksNotesList);
  public loadingUpdateAlertMessage$ = this.store.select(customersQuery.getLoadingAlertMessage);
  public selectedCustomer: CustomerDetails;
  public orderTypes: OrderType[];
  private unSubscribe$ = new Subject<void>();
  isEditOrAddNoteTask: boolean;
  routedParamCustomerNumber: number = this.route.snapshot.params.id;
  searchValue: string;
  rowData = [];
  listTaskNotesFilter: ListTasksNotes;

  noteTaskForm: UntypedFormGroup;

  constructor(
    private store: Store<CustomersPartialState>,
    private route: ActivatedRoute,
    private apiService: ApiService,
    private coreUiStore: Store<CoreUiPartialState>,
    private formBuilder: UntypedFormBuilder,
    private _location: Location,
    @Inject(LOCALE_ID) public locale
  ) {}

  ngOnInit() {
    this.noteTaskForm = this.formBuilder.group({
      alertMessageLastUpdated: [''],
      alertMessageText: [''],
      alertMessageLastUpdatedBy: [''],
    });

    // this.getListTaskNotes();

    this.store.dispatch(
      new GetAlertMessageAction({
        customerNumber: this.routedParamCustomerNumber,
      })
    );
    this.store
      .select(customersQuery.getAlertMessage)
      .pipe(takeUntil(this.unSubscribe$))
      .subscribe((alertMessage) => {
        if (alertMessage && alertMessage.alertUpdatedDate !== ' ' && alertMessage.alertUpdatedTime !== 0) {
          this.noteTaskForm.patchValue({
            alertMessageText: alertMessage.alertMessage,
            alertMessageLastUpdated: `${getLocalLocaleDate(alertMessage.alertUpdatedDate, this.locale)} - ${alertMessage.alertUpdatedTime}`,
            alertMessageLastUpdatedBy: alertMessage.alertUpdatedBy,
          });
        }
      });
    this.apiService
      .fetchCustomerDetails({
        customerNumber:this.routedParamCustomerNumber,
      })
      .pipe(takeUntil(this.unSubscribe$))
      .subscribe((customerDetails) => {
        this.selectedCustomer = customerDetails.SearchResults[0];
      });
    this.store
      .select(customersQuery.getTasksNotesList)
      .pipe(takeUntil(this.unSubscribe$))
      .subscribe((tasksNotes) => {
        this.rowData = tasksNotes;
      });
    this.coreUiStore
      .select(getOrderTypes)
      .pipe(takeUntil(this.unSubscribe$))
      .subscribe((orderTypes) => {
        this.orderTypes = orderTypes;
      });
  }

  getListTaskNotes() {
    this.initListTaskNotesFilter();
    this.listTaskNotesFilter.customerNumber = this.routedParamCustomerNumber.toString();
    this.store.dispatch(new ListTasksNotesAction(this.listTaskNotesFilter));
  }

  saveAlertMessage() {
    this.store.dispatch(
      new UpdateAlertMessageAction({
        actionCode: 'A',
        customerNumber: this.routedParamCustomerNumber,
        alertMessage: this.noteTaskForm.controls.alertMessageText.value,
      })
    );
  }

  navigateBack() {
    this._location.back();
  }

  clearAlertMessage() {
    this.noteTaskForm.patchValue({
      alertMessageText: '',
      alertMessageLastUpdated: '',
      alertMessageLastUpdatedBy: '',
    });

    this.store.dispatch(
      new UpdateAlertMessageAction({
        actionCode: 'D',
        customerNumber: this.routedParamCustomerNumber,
        alertMessage: '',
      })
    );
  }

  initListTaskNotesFilter() {
    this.listTaskNotesFilter = {
      type: '',
      ownerIdentifier: '',
      customerNumber: '',
      assignee: '',
      completeYN: '',
      fromDate: '',
      toDate: '',
    };
  }
}
